import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import ExpandableImage from '../../components/ExpandableImage'
import ResourceLink from './ResourceLink'

const ResourceItem = ({
  title,
  description,
  image,
  fileType,
  fileSize,
  resourceUrl,
  isDownload,
}) => {
  return (
    <div className="c-resourcesItem">
      <div className="row">
        <div className="col-12 text-center col-md-4">
          <ExpandableImage imageData={image}>
            <img
              src={`${image.url}?fit=crop&w=360&h=360`}
              className="c-resourcesItem__thumbnail img-fluid"
            />
          </ExpandableImage>
        </div>
        <div className="col-12 col-md-8 col-lg-4 px-xl-5">
          <h2 className="c-resourcesItem__title">{title}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
        <div className="col-12 col-lg-4">
          <div className="row">
            <div className="col-6 col-lg-12">
              {isDownload && (
                <Fragment>
                  <h3 className="c-resourceItem__ext">{fileType}</h3>
                  <p>{fileSize}</p>
                </Fragment>
              )}
            </div>
            <div className="col-6 text-right col-lg-12 text-lg-left">
              <ResourceLink url={resourceUrl} isDownload={isDownload} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ResourceItem.defaultProps = {
  isDownload: true,
}

ResourceItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  fileType: PropTypes.string.isRequired,
  fileSize: PropTypes.string.isRequired,
  resourceUrl: PropTypes.string.isRequired,
  isDownload: PropTypes.bool,
}

export default ResourceItem
